import { Tooltip } from '@mui/material'
import React from 'react'

import AttackArgIcon from 'components/common/AttackArgIcon'
import theme from 'theme'

export const ArgIcon: React.FC<{
  className?: string
  icon: string
  attack?: string
  tooltip: React.ReactNode
}> = ({ className, tooltip, icon, attack }) => {
  return (
    <div className={className}>
      <Tooltip
        arrow
        placement="top"
        role="tooltip" // Avoid a11y violations
        title={tooltip || 'Argument Icon'}
      >
        <div
          css={{
            height: theme.space[5],
            width: theme.space[5],
            flex: `0 0 ${theme.space[5]}px`
          }}
        >
          <div
            css={{
              borderColor: theme.colors.gray[1],
              backgroundColor: 'white',
              borderStyle: 'solid',
              borderWidth: 1,
              borderRadius: '100%',
              height: '100%',
              width: '100%',
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex'
            }}
          >
            <AttackArgIcon
              attack={attack}
              css={{ color: theme.colors.steel[1] }}
              icon={icon}
            />
          </div>
        </div>
      </Tooltip>
    </div>
  )
}
